__turbopack_context__.v({
  "fade-in": "mCrdva_fade-in",
  "urgent_message_popover": "mCrdva_urgent_message_popover",
  "urgent_message_popover_close_button": "mCrdva_urgent_message_popover_close_button",
  "urgent_message_popover_content": "mCrdva_urgent_message_popover_content",
  "urgent_message_popover_donate_button": "mCrdva_urgent_message_popover_donate_button",
  "urgent_message_popover_donate_button_heart_icon": "mCrdva_urgent_message_popover_donate_button_heart_icon",
  "urgent_message_popover_donate_button_station": "mCrdva_urgent_message_popover_donate_button_station",
  "urgent_message_popover_headline": "mCrdva_urgent_message_popover_headline",
  "urgent_message_popover_illustration": "mCrdva_urgent_message_popover_illustration",
  "urgent_message_popover_text": "mCrdva_urgent_message_popover_text",
  "vanish": "mCrdva_vanish",
});
